module.exports = __webpack_public_path__ + "static/img/1vr1.0d4d2899.png";